import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import ToggleAnalyticsCard from './ToggleAnalyticsCard';
import { CryptoCard } from '../../../@jumbo/components/Common';
import RevenueGraph2 from './RevenueGraph2';
import RevenueGraph3 from './RevenueGraph3';
import { getMyDate1, getMyDate2, getMyDate4, formatPrice } from '../../../@jumbo/utils/commonHelper';

const useStyles = theme => ({});

class PanelRevenue2 extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    var color2 = '#F39711';

    const intranet = {
      monthlyTopChart: {
        title: '',
        hoverButton: {
          text: '',
          color: '#5D9405',
          hoverText: <IntlMessages id="cockpit.before" />,
          hoverColor: '#fff',
        },
        analyticData: {
          amount: '',
          label: '',
          percentage: '',
          onHover: {
            amount: '',
            percentage: '',
          },
        },
        primaryColor: {
          solid: '#ADDC4C',
          light: '#D7F5B1',
        },
        greenColor: {
          solid: '#ADDC4C',
          light: '#D7F5B1',
        },
        secondaryColor: {
          solid: '#C8372D',
          light: '#FADEE3',
        },
        redColor: {
          solid: '#C8372D',
          light: '#FADEE3',
        },
        chartData: {
          current: [],
          past: [],
        },
      },
    };
    const mydata = intranet.monthlyTopChart;
    if (this.props.mode == 'revenue') {
      color2 = '#F39711';
      mydata.title = <IntlMessages id="cockpit.revenue" />;
    }
    if (this.props.mode == 'income') {
      color2 = '#0078D7';
      mydata.title = <IntlMessages id="cockpit.income" />;
    }
    if (this.props.mode == 'adr') {
      color2 = '#00B294';
      mydata.title = <IntlMessages id="cockpit.adr" />;
    }
    if (this.props.mode == 'revpar') {
      color2 = '#744da9';
      mydata.title = <IntlMessages id="cockpit.revpar" />;
    }

    if (this.props.mode == 'nights') {
      color2 = '#f44336';
      mydata.title = <IntlMessages id="cockpit.nights" />;
    }

    if (this.props.mode == 'occupancy') {
      color2 = '#f50057';
      mydata.title = <IntlMessages id="cockpit.occupancy" />;
    }

    if (this.props.mode == 'rooms') {
      color2 = '#00bcd4';
      mydata.title = <IntlMessages id="cockpit.rooms" />;
    }

    const myDate = new Date();
    const day1 = myDate.toISOString().split('T')[0];
    const day2 = day1;
    const myDate2 = new Date();
    myDate2.setDate(myDate.getDate() - 1);
    const day3 = myDate2.toISOString().split('T')[0];
    const day4 = day3;

    this.state = {
      panel1: mydata,
      data: this.props.data,
      color: color2,
      currentPeriod: 'today',
      day1: day1,
      day2: day2,
      day3: day3,
      day4: day4,
    };
    this.UpdatePeriod = this.updatePeriod.bind(this);
    this.updatePeriod(this.props.data, 7);
  }

  updatePeriod(data, days) {
    if (data == null) return;
    const { intl } = this.props;
    var mydata = this.state.panel1;
    mydata.chartData.current = data.CurrentValues;
    mydata.chartData.past = data.PastValues;

    var nationalCurrency = '';
    if (this.props.auth.authUser.clouduser == 1)
      nationalCurrency = ' ' + this.props.auth.authUser.currencies.find(({ national }) => national === true).code;
    {
      nationalCurrency = ' ' + this.props.auth.authUser.currencies[0].code;
    }

    if (this.props.mode == 'occupancy') nationalCurrency = '%';
    if (
      this.props.mode == 'rooms' ||
      this.props.mode == 'nights' ||
      this.props.mode == 'alos' ||
      this.props.mode == 'dta' ||
      this.props.mode == 'reservations' ||
      this.props.mode == 'cancellations'
    )
      nationalCurrency = '';

    if (this.props.full == 'true') mydata.analyticData.amount = formatPrice(data.Value1, 'hr', 0) + nationalCurrency;
    else
      mydata.analyticData.amount =
        formatPrice(data.CurrentValues[data.CurrentValues.length - 1].value, 'hr', 0) + nationalCurrency;

    mydata.analyticData.percentage = data.Difference;

    mydata.chartData.current.map((item, index) => {
      item.label = this.props.mode != 'seg' ? getMyDate4(item.label, 'hr') : item.label;
      item.value = item.value; //formatPrice(item.value, 'hr');
      if (mydata.chartData.past != null && this.props.mode != 'seg') item.previous = mydata.chartData.past[index].value; //formatPrice(mydata.chartData.past[index].value, 'hr');
    });
    if (mydata.chartData.past != null)
      mydata.chartData.past.map((item, index) => {
        item.label = this.props.mode != 'seg' ? getMyDate4(item.label, 'hr') : item.label;
        item.value = item.value; //formatPrice(item.value, 'hr');
      });

    var hovertext = '';
    if (days == 1) hovertext = intl.formatMessage({ id: 'tabs.today' });
    else hovertext = days + ' ' + intl.formatMessage({ id: 'cockpit.days' });
    mydata.hoverButton.text = hovertext;

    if (this.props.mode != 'seg') mydata.analyticData.onHover.amount = data.Value2;
    if (this.props.mode != 'seg' && data.Value1 > data.Value2) mydata.rise = '1';
    else mydata.rise = '0';
    if (mydata.rise == '1' && this.props.mode != 'cancellations') {
      mydata.primaryColor = mydata.greenColor;
      mydata.secondaryColor = mydata.redColor;
    } else {
      mydata.primaryColor = mydata.redColor;
      mydata.secondaryColor = mydata.greenColor;
    }

    this.setState({ panel1: mydata });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
      this.UpdatePeriod(this.props.data, 7);
      console.log(this.props.data);
    }
  }

  componentDidMount() {}

  render() {
    var color = '#8DCD03';
    if (this.props.mode != 'seg') {
      if (this.state.panel1.analyticData.percentage.substr(0, 1) == '-') color = '#E00930';
    }
    let color2 = '',
      title = '';
    console.log(this.props);
    if (this.props.mode == 'revenue') {
      color2 = '#F39711';
      title = <IntlMessages id="cockpit.revenue" />;
    }
    if (this.props.mode == 'income') {
      color2 = '#0078D7';
      if (this.props.auth.authUser.clouduser == 1) title = <IntlMessages id="cockpit.income" />;
      if (this.props.auth.authUser.clouduser == 0) title = <IntlMessages id="cockpit.income2" />;
    }
    if (this.props.mode == 'adr') {
      color2 = '#00B294';
      if (this.props.auth.authUser.clouduser == 1) title = <IntlMessages id="cockpit.adr" />;
      if (this.props.auth.authUser.clouduser == 0) title = <IntlMessages id="cockpit.gADR" />;
    }
    if (this.props.mode == 'revpar') {
      color2 = '#744da9';
      if (this.props.auth.authUser.clouduser == 1) title = <IntlMessages id="cockpit.revpar" />;
      if (this.props.auth.authUser.clouduser == 0) title = <IntlMessages id="cockpit.gRevPar" />;
    }
    if (this.props.mode == 'nights') {
      color2 = '#f44336';
      title = <IntlMessages id="cockpit.nights" />;
    }

    if (this.props.mode == 'occupancy') {
      color2 = '#f50057';
      title = <IntlMessages id="cockpit.occupancy" />;
    }

    if (this.props.mode == 'rooms') {
      color2 = '#00bcd4';
      title = <IntlMessages id="cockpit.rooms" />;
    }

    if (this.props.mode == 'alos') {
      color2 = '#d4009f';
      title = <IntlMessages id="cockpit.ALOS" />;
    }

    if (this.props.mode == 'agr') {
      color2 = '#00d42e';
      title = <IntlMessages id="cockpit.gAGR" />;
    }

    if (this.props.mode == 'reservations') {
      color2 = '#00d455';
      title = <IntlMessages id="cockpit.reservations" />;
    }
    if (this.props.mode == 'cancellations') {
      color2 = 'rgba(255,103,103,0.68)';
      title = <IntlMessages id="cockpit.cancellations" />;
    }

    if (this.props.mode == 'dta') {
      color2 = '#586fb1';
      title = <IntlMessages id="cockpit.daysToBooking" />;
    }

    if (this.props.mode == 'seg') {
      color2 = '#586fb1';
      title = <IntlMessages id="cockpit.segmentation" />;
    }

    return (
      <CryptoCard
        title={this.props.title}
        amount={this.state.panel1.analyticData.amount}
        progress={
          this.props.mode != 'seg' ? { value: this.state.panel1.analyticData.percentage, icon: 'info', color: color } : {}
        }>
        {this.props.loadingData === true && <CircularProgress color="inherit" />}
        {this.state.panel1.chartData.past != null && (this.props.loadingData == false || this.props.loadingData == null) && (
          <RevenueGraph2
            mymode={this.props.mode}
            color={color2}
            data={this.state.panel1.chartData.current}
            color2="#E81123"
          />
        )}
        {this.state.panel1.chartData.past == null && (this.props.loadingData == false || this.props.loadingData == null) && (
          <RevenueGraph2 mymode={this.props.mode} color={color2} data={this.state.panel1.chartData.current} />
        )}
      </CryptoCard>
    );
    //    else return <></>;
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(PanelRevenue2)));
